package top.wcpe.allincore.ui.runtime.ir.prop

import top.wcpe.allincore.ui.runtime.element.Modal
import top.wcpe.allincore.ui.runtime.ir.eval.ValueCoercion
import kotlin.jvm.JvmStatic

/**
 * Modal 元素属性贡献者：登记 dismissOnOutsideClick / dismissOnEsc / backdrop /
 * centered / zIndex 五项静态属性。
 */
@Suppress("CyclomaticComplexMethod", "LongMethod")
internal object ModalPropContributor {

    @JvmStatic
    fun contribute(m: MutableMap<String, PropBinding>) {
        m.put(
            "dismissOnOutsideClick",
            PropBinding.writeOnly { el, v ->
                if (v != null && el is Modal) {
                    el.dismissOnOutsideClick(ValueCoercion.toBool(v))
                }
            },
        )
        m.put(
            "dismissOnEsc",
            PropBinding.writeOnly { el, v ->
                if (v != null && el is Modal) {
                    el.dismissOnEsc(ValueCoercion.toBool(v))
                }
            },
        )
        m.put(
            "centered",
            PropBinding.writeOnly { el, v ->
                if (v != null && el is Modal) {
                    el.centered(ValueCoercion.toBool(v))
                }
            },
        )
        m.put(
            "offsetX",
            PropBinding.writeOnly { el, v ->
                if (v != null && el is Modal) {
                    el.offsetX(ValueCoercion.toFloat(v))
                }
            },
        )
        m.put(
            "offsetY",
            PropBinding.writeOnly { el, v ->
                if (v != null && el is Modal) {
                    el.offsetY(ValueCoercion.toFloat(v))
                }
            },
        )
        m.put(
            "fullscreen",
            PropBinding.writeOnly { el, v ->
                if (v != null && el is Modal) {
                    el.fullscreen(ValueCoercion.toBool(v))
                }
            },
        )
        m.put(
            "passthrough",
            PropBinding.writeOnly { el, v ->
                if (v != null && el is Modal) {
                    el.passthrough(ValueCoercion.toBool(v))
                }
            },
        )
        m.put(
            "spotlightTarget",
            PropBinding.writeOnly { el, v ->
                if (v != null && el is Modal) {
                    el.spotlightTargetId(v.toString())
                }
            },
        )
        m.put(
            "spotlightPadding",
            PropBinding.writeOnly { el, v ->
                if (v != null && el is Modal) {
                    el.spotlightPadding(ValueCoercion.toFloat(v))
                }
            },
        )
        m.put(
            "spotlightDimColor",
            PropBinding.writeOnly { el, v ->
                if (v != null && el is Modal) {
                    el.spotlightDimColor(ValueCoercion.toIntColor(v))
                }
            },
        )
        m.put(
            "anchorTarget",
            PropBinding.writeOnly { el, v ->
                if (v != null && el is Modal) {
                    el.anchorTargetId(v.toString())
                }
            },
        )
        m.put(
            "anchorPosition",
            PropBinding.writeOnly { el, v ->
                if (v != null && el is Modal) {
                    el.anchorPosition(v.toString())
                }
            },
        )
        m.put(
            "anchorAlign",
            PropBinding.writeOnly { el, v ->
                if (v != null && el is Modal) {
                    el.anchorAlign(v.toString())
                }
            },
        )
        m.put(
            "anchorGap",
            PropBinding.writeOnly { el, v ->
                if (v != null && el is Modal) {
                    el.anchorGap(ValueCoercion.toFloat(v))
                }
            },
        )
        m.put(
            "backdrop",
            PropBinding.writeOnly { el, v ->
                if (v != null && el is Modal) {
                    el.backdrop(ValueCoercion.toIntColor(v))
                }
            },
        )
        m.put(
            "zIndex",
            PropBinding.writeOnly { el, v ->
                if (v != null && el is Modal) {
                    el.zIndex(ValueCoercion.toDouble(v))
                }
            },
        )
        m.put(
            "fadeIn",
            PropBinding.writeOnly { el, v ->
                if (v != null && el is Modal) {
                    el.fadeInMs(ValueCoercion.toDouble(v).toLong())
                }
            },
        )
    }
}
